// The one definition of a shop's address: /shop/<handle>, lowercase (the
// handle's key, as the API matches it).
export const shopPath = (handle) => (handle ? `/shop/${encodeURIComponent(String(handle).toLowerCase())}` : null);

// The handle a product's "Sold by" links to. seller_shop_name carries the
// seller's capitals; the address uses its lowercase key.
export const productShopPath = (product) => shopPath(product?.seller_shop_name);
